module.exports = __webpack_public_path__ + "static/checkmark-fecbb664b9a2fd9d97056b7c08848809.png";